import type { RootState, AppDispatch } from 'store/types';

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// Use instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
